import { type ContentMetricRow, LoadTimeRating } from '../components/ContentMetricsTable.tsx';

export const mockContentMetrics: ContentMetricRow[] = [
	{
		id: '1',
		contentTitle: 'Getting started',
		loadTimeRating: LoadTimeRating.SLOW,
		medianLoadTime: '1.2s',
		views: 100,
		space: 'My Space',
		contentOwner: 'John Doe',
	},
	{
		id: '2',
		contentTitle: 'Q4 Report',
		loadTimeRating: LoadTimeRating.MODERATE,
		medianLoadTime: '1.2s',
		views: 50,
		space: 'My Space',
		contentOwner: 'John Doe',
	},
	{
		id: '3',
		contentTitle: 'Architecture overview',
		loadTimeRating: LoadTimeRating.FAST,
		medianLoadTime: '1.2s',
		views: 16,
		space: 'My Space',
		contentOwner: 'John Doe',
	},
];
